export default {
  name: '313C',
  recruitment_game: 'Náborová hra',
  back: 'Späť',
  cancel: 'Zrušiť',
  continue: 'Pokračovať',
  skip: 'Preskočiť',
  start: 'Štart',
  close: 'Zavrieť',
  help: 'Pomoc',
  time_left: 'Zostávajúci čas',
  progress: 'Postup',
  privacy_policy: 'Ochrana osobných údajov',
  cookies_policy: 'Politika cookies a Podmienky',
  faq: 'Otázky a odpovede',
  messages: 'Správy',
  unread: 'neprečítané',
  start_recording: 'Spustenie nahrávania',
  stop_recording: 'Zastaviť nahrávanie',
  remove_record: 'Odstrániť záznam',
  play_video: 'Prehrať',
  stop_video: 'Zastaviť',
  mute_video: 'Stíšiť',
  unmute_video: 'Obnoviť zvuk',
  replay_video: 'Prehrať znova',
  choose: 'Vybrať',
  badges: {
    title: 'Odmeny',
    badge: 'Odmena',
    my_badges: 'Moje odmeny',
    received: 'Získal/a si odmenu',
    continue: 'Pokračuj v hre',
    show_badges: 'Pozri si odmeny',
    show_badge: 'Pozri si odmenu',
  },
  record_test: {
    intro: 'TEST NASTAVENÍ KAMERY A MIKROFÓNU',
    content:
      'Pred začatím práce s nástrojom si otestuj svoje nastavenia. V poli nižšie by malo byť vidieť obraz z tvojej kamery. Ak ho vidíš, znamená to, že tvoje nastavenia sú pravdepodobne správne - pre istotu nahraj a prehraj video. Ak nevidíš obraz z kamery, nemôžeš prehrať nahrávku alebo máš iné pochybnosti, klikni na tlačidlo “RIEŠENIE PROBLÉMOV”',
    troubleshoot: 'Riešenie Problémov',
    settings: 'Nastavenia',
  },
  questions: {
    progress: 'Otázka',
    accept: 'Potvrdiť',
    question_counter: 'Otázka <strong>{current}</strong> z <strong>{total}</strong>',
    time_for_answer: 'Čas na odpoveď',
    question_has_already_been_answered: 'Táto otázka už bola zodpovedaná.',
  },
  not_found: {
    code: '404',
    title: 'Stránka neexistuje',
    content:
      'Stránka, ktorú ste hľadali, nebola nájdená. Mohlo byť odstránené, meno bolo zmenené alebo to vôbec neexistovalo',
  },
  phone: 'Číslo telefónu',
  select_language: 'Vyberte jazyk / Choose language',
  title:
    'Táto stránka používa súbory cookie na zabezpečenie vynikajúceho užívateľského zážitku. Používaním tejto stránky súhlasíte s používaním',
  link: 'súborov cookie',
  button: 'Zavrieť',
  warning: {
    title: 'Došla k chybe',
    content: 'Skúste to znovu a ak sa chyba bude opakovať, dajte nám vedieť na',
    content_without_email:
      'Skúste to znovu a ak sa chyba bude opakovať, dajte nám vedieť na našu technickú podporu',
    confirm: 'Zavrieť',
  },
  end_time: {
    title: 'Nahlásiť chybu',
    content: 'Ak sa počas hrania objaví chyba, kontaktujte nás prosím e-mailom na adresu:',
  },
  record_video_error: {
    not_allowed_title: 'Chýbajúce oprávnenia',
    not_allowed_desc:
      'Žiaden prístup ku kamere a/alebo mikrofónu. Skontroluj nastavenia prehliadača a umožni prístup.',
    not_found_title: 'Žiadne pripojené zariadenie',
    not_found_desc:
      'Nenašli sa kamera ani mikrofón. Skontrolujte, či sú zariadenia správne pripojené.',
    not_readable_title: 'Zariadenie je používané inou aplikáciou',
    not_readable_desc:
      'Kamera a/alebo mikrofón sa používajú inou aplikáciou. Zatvorte ju a skúste to znova (možno bude potrebné obnoviť stránku).',
    unknown_title: 'Neznáma chyba',
    unknown_desc:
      'Došlo k neznámej chybe (napr. problémy s ovládačmi alebo poškodené zariadenie). Pozrite si časť Riešenie problémov a skúste to znova.',
    try_again: 'Obnoviť stránku',
    corrupted_desc:
      'Nahrávka sa neuložila správne a obraz sa počas prehrávania zasekáva. Nahrajte prosím svoju odpoveď znova.',
  },
  unsupported_os: {
    content: `
      <span class="swal2-title">Nepodporované zariadenie</span>
      <hr>
      <div class="swal2-wrapper">
        <p>Pre pokračovanie, prosím, použite <strong>iné zariadenie a/alebo iný prehliadač.</strong></p>
        <p>Nástroj na nábor, ktorý sa chystáte použiť, obsahuje aspoň jednu úlohu, pri ktorej budete musieťnahrávať svoju odpoveď vo formáte videa. Bohužiaľ, nie všetky zariadenia a/alebo prehliadačeumožňujú tento krok vykonať správne.</p>
        <p><strong>Ak vidíte túto obrazovku, znamená to, že vaše zariadenie a/alebo prehliadač nedokážu zaručiťsprávne nahratie a odoslanie video súboru.</strong> Nižšie nájdete odporúčané nastavenia.</p>
        <br>
        <p><strong>Stolné zariadenia:</strong></p>
        <p>Windows: Google Chrome, Firefox, Opera, MS Edge</p>
        <p>macOS: Google Chrome, Firefox, Opera, Safari, MS Edge</p>
        <p>Ubuntu: Google Chrome, Firefox, Opera</p>
        <br>
        <p><strong>Mobilné zariadenia:</strong></p>
        <p>Andriod: Google Chrome, Firefox, Opera</p>
        <p>iOS (iPhone/iPad): Safari</p>
      </div>
      <hr>
    `,
  },
  skip_stage_without_record: {
    title: 'Určite chceš preskočiť túto úlohu?',
    content:
      '<p>Nahrávanie videoodpovede na túto úlohu nie je povinné, ale odporúčame ho – pomôže nám lepšie ťa spoznať. Určite chceš preskočiť nahrávanie videoodpovede?</p>',
  },
  skip_stage_with_record: {
    title: 'Ste si istý, že chcete úlohu preskočiť?',
    content:
      '<p>Máte v úmysle preskočiť uloženie nahraného videoodpovede - nebude dostupné osobe vykonávajúcej výberový proces. Nahranie videoodpovede pre túto úlohu nie je povinné, ale odporúča sa - pomôže nám lepšie vás spoznať. Ste si istí, že chcete preskočiť uloženie nahraného videoodpovede?</p>',
  },
  instruction_camera: {
    content: `
      <span class="swal2-title">Riešenie problémov s kamerou a mikrofónom</span>
      <hr>
      <div class="swal2-wrapper">
      <p>Ak nahrávanie alebo prehrávanie nie je správne, môžeš nasledovať niekoľko krokov, ktoré by mali problém vyriešiť. Najčastejšie príčiny problémov vyplývajú z nastavení zariadenia, vrátane iných programov alebo aplikácií, ktoré súčasne používajú kameru a/alebo mikrofón.</p>
      <p>Možné riešenia problému:</p>
      <ol>
        <li>Uisti sa, že prehliadač má povolenia na používanie mikrofónu a kamery. Ak nie, zmeň nastavenia a obnov stránku.</li>
        <li>Uisti sa, že žiadna iná aplikácia alebo program práve nepoužíva kameru/mikrofón (napr. MS Teams, Photo Booth alebo FaceTime) - zatvor aplikácie, ktoré blokujú možnosť použitia kamery prehliadačom a obnov stránku.</li>
        <li>Skontroluj, či je tvoj prehliadač aktualizovaný na najnovšiu verziu - ak nie, aktualizuj prehliadač a otestuje znova.</li>
        <li>Ak predchádzajúce kroky nepomohli, skús použiť iný prehliadač alebo zariadenie.</li>
      </ol>
      <p>Ak problém pretrváva, daj nám vedieť na { supportEmail } zaslaním informácií o zariadení a prehliadači, na ktorých sa problém vyskytuje.</p>
      </div>
      <hr>
    `,
  },
  recaptcha: 'Zaškrtnite Recaptcha',
  phone_incorrect: 'Vložte platné telefónne číslo',
  missing_answer_error:
    'Pre pokračovanie vyberte dve odpovede: jednu palcom hore a jednu palcom dole.',
  rotate_phone_video: 'Otočte telefón vodorovne, aby ste zobrazili video vo väčšej veľkosti',
  rotate_phone_image: 'Otočte telefón vodorovne, aby ste zobrazili obrázok vo väčšej veľkosti',
  attachments: 'Prílohy',
  debugbar: {
    title: 'Poloha kurzora',
    latutide: 'Zemepisná šírka',
    longitude: 'Zemepisná dĺžka',
    hint: 'Kliknite kdekoľvek na obrazovke a zobrazia sa súradnice polohy kurzora',
  },
  loading: 'Načítava sa...',
};
